import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

export default function JobSkeleton() {
  const screenWidth = window.innerWidth;

  const getSkeletonWidth = () => {
    if (screenWidth > 1200) return "20vw";
    if (screenWidth > 768) return "10vw";
    return "70vw";
  };

  return (
    <div
      className="d-flex flex-column min-vh-100 gap-4 p-3"
      style={{ alignItems: "flex-end" }}
    >
      {[...Array(3)].map((_, index) => (
        <div
          key={index}
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <Skeleton
            width={getSkeletonWidth()}
            height="25vh"
            baseColor="#ddd"
            highlightColor="#f5deb3"
            style={{ marginTop: "1vh" }}
          />
        </div>
      ))}
    </div>
  );
}
